import { createFileRoute } from "@tanstack/react-router";
import { TargetsPage } from "@/features/targets/TargetsPage";

export const Route = createFileRoute("/_app/reports/targets")({ component: TargetsPage });
